import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

/**
 * HU013 - Rotas das telas de Validação de Titulação, uma por perfil:
 *  - Médico Participante  → /titulacao
 *  - Técnico MS (CGAPP)   → /administracao/titulacao
 *  - Gestores             → /consulta-titulacao
 */
export const titulacaoRoutes: Routes = [
  {
    path: 'titulacao',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Validação de Titulação',
      breadcrumb: [{ label: 'Formação' }, { label: 'Validação de Titulação' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./titulacao-medico/titulacao-medico.component').then(
            (m) => m.TitulacaoMedicoComponent
          ),
        data: {
          title: 'Validação de Titulação',
          roles: [Role.TITULACAO_ADICIONAR_PROFISSIONAL, Role.TITULACAO_VISUALIZAR_PROFISSIONAL],
          breadcrumb: [
            { label: 'Formação' },
            { label: 'Validação de Titulação', url: '/titulacao' },
          ],
        },
      },
    ],
  },
  {
    path: 'administracao/titulacao',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Validação de Titulação',
      breadcrumb: [{ label: 'Administração' }, { label: 'Validação de Titulação' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./titulacao-tecnico/titulacao-tecnico.component').then(
            (m) => m.TitulacaoTecnicoComponent
          ),
        data: {
          title: 'Validação de Titulação',
          roles: [Role.TITULACAO_VALIDAR_TECNICO, Role.TITULACAO_VISUALIZAR_ADMINISTRACAO],
          breadcrumb: [
            { label: 'Administração' },
            { label: 'Validação de Titulação', url: '/administracao/titulacao' },
          ],
        },
      },
    ],
  },
  {
    path: 'consulta-titulacao',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Consulta de Titulação',
      breadcrumb: [{ label: 'Formação' }, { label: 'Consulta de Titulação' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./titulacao-gestor/titulacao-gestor.component').then(
            (m) => m.TitulacaoGestorComponent
          ),
        data: {
          title: 'Consulta de Titulação',
          roles: [Role.TITULACAO_VISUALIZAR_ADMINISTRACAO],
          breadcrumb: [
            { label: 'Formação' },
            { label: 'Consulta de Titulação', url: '/consulta-titulacao' },
          ],
        },
      },
    ],
  },
];
